(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* SEO/CWV fix 2026-10-02: start below-the-fold hero videos only when they approach the
     viewport (they are rendered with preload="none"), and pause any hero video that scrolls
     out of view. */
  (() => {
    const init = () => {
      const videos = document.querySelectorAll('video.hero__video:not([data-hero-video-observed])');
      if (!videos.length) return;
      if (!('IntersectionObserver' in window)) {
        videos.forEach((v) => {
          v.setAttribute('data-hero-video-observed', '');
          v.play().catch(() => {});
        });
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) {
              target.play().catch(() => {});
            } else if (!target.paused) {
              target.pause();
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
      videos.forEach((v) => {
        v.setAttribute('data-hero-video-observed', '');
        io.observe(v);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
